<template>
  <el-row id="app">
    <el-col>
      <el-row>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <trade-term-out />
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <trade-term-in />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24">
          <trade-term-years />
          

        </el-col>
      </el-row> -->
    </el-col>
  </el-row>
</template>

<script>
  import TradeTermIn from '@/components/TradeTermIn'
  import TradeTermOut from '@/components/TradeTermOut'
  import TradeTermYears from '@/components/TradeTermYears'
  
  
  export default {
    name: 'App',
    data() {
      return {
        radio1: '1',
        radio2: '1',
      }
    },
    components: {
      
      TradeTermIn,
      TradeTermOut,
      TradeTermYears
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ByTradeTerm.vue